import React, { useEffect, useState } from "react";
import axios from "axios";
import Hoot from "../../Hoot";
import toast, { Toaster } from "react-hot-toast";

import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

import {
  FiPlus,
  FiSearch,
  FiGrid,
  FiList,
  FiEdit,
  FiTrash,
  FiEye,
  FiFileText,
} from "react-icons/fi";


/* =====================================================
   CSS — SaaS LEVEL UI
===================================================== */

const styles = `
:root{
 --primary:#6366f1;
 --bg:#f6f7fb;
 --card:#ffffff;
 --border:#e6e8f0;
 --text:#111827;
 --muted:#6b7280;
}

.shell{
 background:var(--bg);
 padding:20px;
 min-height:100vh;
}

.header{
 display:flex;
 justify-content:space-between;
 align-items:center;
 margin-bottom:18px;
}

.title{
 font-size:1.4rem;
 font-weight:800;
}

.toolbar{
 display:flex;
 gap:10px;
 margin-bottom:16px;
}

.search{
 border-radius:12px;
 padding:8px 12px;
 border:1px solid var(--border);
 width:280px;
}

/* GRID */

.grid{
 display:grid;
 grid-template-columns:repeat(auto-fill,minmax(260px,1fr));
 gap:16px;
}

.cardx{
 background:var(--card);
 border-radius:18px;
 padding:12px;
 border:1px solid var(--border);
 transition:.25s;
 cursor:pointer;
}

.cardx:hover{
 transform:translateY(-6px);
 box-shadow:0 20px 40px rgba(0,0,0,.08);
}

.preview{
 height:180px;
 background:#f1f2f6;
 border-radius:12px;
 display:flex;
 align-items:center;
 justify-content:center;
 overflow:hidden;
}

.preview iframe{
 width:100%;
 height:100%;
 border:none;
}

.doc-title{
 font-weight:700;
 margin-top:8px;
}

.actions{
 display:flex;
 justify-content:flex-end;
 gap:6px;
 margin-top:6px;
}

.icon-btn{
 border:none;
 background:#f3f4f6;
 padding:6px;
 border-radius:8px;
 cursor:pointer;
}

.icon-btn:hover{
 background:#e5e7eb;
}

/* TABLE */

.tablex{
 width:100%;
 background:white;
 border-radius:14px;
 overflow:hidden;
}

.tablex th, .tablex td{
 padding:10px;
 border-bottom:1px solid var(--border);
}

.editor{
 min-height:420px;
 border:1px solid var(--border);
 border-radius:12px;
 padding:14px;
 outline:none;
}
`;



/* =====================================================
   TEMPLATE HTML DEFAULT
===================================================== */

const defaultTemplate = `
<div style="font-family:Arial;padding:40px">
<h1>Relatório EDUALL</h1>
<p>Este é um template completo.</p>
</div>
`;



/* =====================================================
   COMPONENT
===================================================== */

export default function DocumentsManager(){

const [docs,setDocs] = useState([]);
const [view,setView] = useState("grid");
const [search,setSearch] = useState("");

const [open,setOpen] = useState(false);
const [editing,setEditing] = useState(null);

const [title,setTitle] = useState("");
const [html,setHtml] = useState(defaultTemplate);

const [previewOpen,setPreviewOpen] = useState(false);
const [previewHtml,setPreviewHtml] = useState("");

const [loading,setLoading] = useState(false);



/* =====================================================
   LOAD
===================================================== */

const load = async()=>{

try{

setLoading(true);

const res = await axios.get(Hoot()+"documents",{withCredentials:true});

setDocs(res.data || []);

}catch{
 toast.error("Erro ao carregar documentos");
}

finally{
 setLoading(false);
}

};

useEffect(()=>{load()},[]);



/* =====================================================
   SAVE
===================================================== */

const save = async()=>{

if(!title.trim()) return toast.error("Título obrigatório");

try{

setLoading(true);

if(editing){

 await axios.put(Hoot()+`documents/${editing.id}`,{
  title,
  html
 },{withCredentials:true});

 toast.success("Documento atualizado");

}else{

 await axios.post(Hoot()+"documents",{
  title,
  html
 },{withCredentials:true});

 toast.success("Documento criado");

}

setOpen(false);
load();

}catch{
 toast.error("Erro ao salvar");
}

finally{
 setLoading(false);
}

};



/* =====================================================
   DELETE
===================================================== */

const remove = async(doc)=>{

if(!window.confirm("Eliminar documento?")) return;

try{

await axios.delete(Hoot()+`documents/${doc.id}`,{withCredentials:true});

toast.success("Documento removido");

load();

}catch{
 toast.error("Erro ao remover");
}

};



/* =====================================================
   FILTER
===================================================== */

const filtered = docs.filter(d=>
 d.title?.toLowerCase().includes(search.toLowerCase())
);



return(
<>
<style>{styles}</style>

<Toaster position="top-right"/>

<div className="shell">

{/* HEADER */}

<div className="header">
<div className="title">Documents</div>

<Button
onClick={()=>{
 setEditing(null);
 setTitle("");
 setHtml(defaultTemplate);
 setOpen(true);
}}
>
<FiPlus/> Add Document
</Button>

</div>



{/* TOOLBAR */}

<div className="toolbar">

<input
className="search"
placeholder="Search..."
value={search}
onChange={e=>setSearch(e.target.value)}
/>

<Button variant="light" onClick={()=>setView("grid")}><FiGrid/></Button>
<Button variant="light" onClick={()=>setView("table")}><FiList/></Button>

</div>



{/* GRID */}

{view==="grid" && (

<div className="grid">

{filtered.map(doc=>(

<div className="cardx" key={doc.id}>

<div
className="preview"
onClick={()=>{
 setPreviewHtml(doc.html);
 setPreviewOpen(true);
}}
>

<iframe srcDoc={doc.html}/>

</div>

<div className="doc-title">{doc.title}</div>

<div className="actions">

<button
className="icon-btn"
onClick={()=>{
 setEditing(doc);
 setTitle(doc.title);
 setHtml(doc.html);
 setOpen(true);
}}
>
<FiEdit/>
</button>

<button
className="icon-btn"
onClick={()=>remove(doc)}
>
<FiTrash/>
</button>

</div>

</div>

))}

</div>

)}



{/* TABLE */}

{view==="table" && (

<table className="tablex">

<thead>
<tr>
<th>Documento</th>
<th>Ações</th>
</tr>
</thead>

<tbody>

{filtered.map(doc=>(

<tr key={doc.id}>
<td>{doc.title}</td>

<td>

<button className="icon-btn"
onClick={()=>{
 setPreviewHtml(doc.html);
 setPreviewOpen(true);
}}
>
<FiEye/>
</button>

<button className="icon-btn"
onClick={()=>{
 setEditing(doc);
 setTitle(doc.title);
 setHtml(doc.html);
 setOpen(true);
}}
>
<FiEdit/>
</button>

<button className="icon-btn"
onClick={()=>remove(doc)}
>
<FiTrash/>
</button>

</td>
</tr>

))}

</tbody>

</table>

)}



{/* =====================================================
   MODAL CREATE / EDIT
===================================================== */}

<Modal
show={open}
onHide={()=>setOpen(false)}
size="xl"
centered
>

<Modal.Header closeButton>
<Modal.Title>
{editing ? "Editar Documento" : "Novo Documento"}
</Modal.Title>
</Modal.Header>

<Modal.Body>

<Form.Group className="mb-3">
<Form.Label>Título</Form.Label>
<Form.Control
value={title}
onChange={e=>setTitle(e.target.value)}
/>
</Form.Group>


<Form.Label>Editor HTML</Form.Label>

<div
className="editor"
contentEditable
suppressContentEditableWarning
onInput={(e)=>setHtml(e.currentTarget.innerHTML)}
dangerouslySetInnerHTML={{__html:html}}
/>

</Modal.Body>

<Modal.Footer>

<Button variant="secondary" onClick={()=>setOpen(false)}>
Cancelar
</Button>

<Button onClick={save}>
{loading ? <Spinner size="sm"/> : "Salvar"}
</Button>

</Modal.Footer>

</Modal>



{/* =====================================================
   PREVIEW MODAL
===================================================== */}

<Modal
show={previewOpen}
onHide={()=>setPreviewOpen(false)}
size="xl"
centered
>

<Modal.Header closeButton>
Preview
</Modal.Header>

<Modal.Body style={{height:"80vh"}}>

<iframe
title="preview"
srcDoc={previewHtml}
style={{width:"100%",height:"100%",border:"none"}}
/>

</Modal.Body>

</Modal>

</div>
</>
);
}
